class AfterpayStyler extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.stylesApplied = false;
  }
  
  connectedCallback() { 
    if (this.applyStyles()) {
      return;
    }
    

    this.observer = new MutationObserver((mutations) => {
      const shouldTry = mutations.some(mutation => {
        return mutation.type === 'childList' && mutation.addedNodes.length > 0;
      });
      
      if (shouldTry && !this.stylesApplied) {
        if (this.applyStyles()) {
          this.observer.disconnect();
          this.observer = null;
        }
      }
    });
    
    this.observer.observe(document.body, { childList: true, subtree: true });
  }
  
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
  
  applyStyles() {
    const afterpay = document.querySelectorAll('afterpay-placement');
    if (afterpay.length === 0) {
      return false; // No elementos encontrados, devolver falso
    }
    
    let stylesSuccessfullyApplied = false;
    
    afterpay.forEach(element => {
      if (element.classList.contains('product-gift__afterpay')) {
        const text = element.shadowRoot.querySelector('.afterpay-text2');
        if (text) {
          text.style.fontFamily = 'Arial';
          text.style.fontSize = '16px';
          text.style.color = '#000';
          text.style.letterSpacing = '0';
        }
        
        const fill = element.shadowRoot.querySelector('.afterpay-logo.logo-cashappafterpay svg g path');
        if (fill) {
          fill.style.fill = 'black';
          stylesSuccessfullyApplied = true;
        }
      }
      if (element.shadowRoot) {
        const text = element.shadowRoot.querySelector('.afterpay-main-text');
        if (text) {
          text.style.fontWeight = '300';
          text.style.fontSize = '17px';
          text.style.lineHeight = '2px';
          text.style.display = 'inline-block';
          text.style.letterSpacing = '0';
          text.style.width = '100%';
          stylesSuccessfullyApplied = true;
        }
        
        const fill = element.shadowRoot.querySelector('.afterpay-logo.logo-cashappafterpay svg g path');
        if (fill) {
          fill.style.fill = 'black';
          stylesSuccessfullyApplied = true;
        }
      }
    });
    
    if (stylesSuccessfullyApplied) {
      this.stylesApplied = true;
    }
    
    return stylesSuccessfullyApplied;
  }
}

customElements.define('afterpay-styler', AfterpayStyler);

if (!document.querySelector('afterpay-styler')) {
  document.body.appendChild(document.createElement('afterpay-styler'));
} 